/**
 * Datadog flag-configuration environment, shared by the browser provider and
 * the server-side subject evaluation. Deliberately free of any Datadog SDK
 * import so the server path never pulls the browser bundle in.
 */

const DD_KNOWN_ENVS = new Set(["production", "staging", "development"]);

/**
 * Map preview-* and other non-standard stages to "preview" so Datadog can
 * resolve flag configuration (it only knows production/staging/development).
 */
export function resolveFeatureFlagEnv(env: string | undefined): string {
  if (!env) {
    return "development";
  }
  return DD_KNOWN_ENVS.has(env) ? env : "preview";
}

/** Datadog site the app's flags are configured in. */
export const DD_FLAGGING_SITE = "us5.datadoghq.com";
